//getSupportNoticeEvents
import * as hpServicesApi from "../../api/healthPlanServicesApi";
import * as types from "../../constants/actionTypes";
import { call, put, select } from "redux-saga/effects";
import { logAPI } from "../../api/andyliticsApi";

export function* getSupportNotifications(params) {
    const start = new Date();
    const domainData = yield select((state) => state.domain);
    const stateData = yield select((state) => state.common);

    if (stateData && stateData.aalDown === false) {
        try {
            if (domainData && domainData.t) {
                const response = yield call(hpServicesApi.ProcessControlEventsApi.getSupportNoticeEvents, domainData.t, params.memberId);
                logAPI("MBHWeb.Saga.HealthPlanServices.ProcessControl.GetSupportNotifications", start, null);
                yield put({ type: types.HP_GET_SUPPORT_NOTIFICATION_SUCCESS, supportMessage: response[0].InProgressMessage, isFetching: false });
            }
        }
        catch (response) {
            console.error(response);
            // Microsoft Edge throws TypeMismatchError when fetch returns 401
            if (response.status === 401 || response.message === 'TypeMismatchError') {
                yield put({ type: types.VERIFY_LOGIN, errorCode: 401 });
                logAPI("MBHWeb.Saga.HealthPlanServices.ProcessControl.GetSupportNotifications.Failure", start, null, '401 - login expired or invalid auth token');
            }
            else {
                yield put({ type: types.HP_GET_SUPPORT_NOTIFICATION_FAILURE, error: response });
                logAPI("MBHWeb.Saga.HealthPlanServices.ProcessControl.GetSupportNotifications.Failure", start, null, response);
            }
        }
    }
    else {
        console.log("webTPASaga: aalDown");
    }
}